'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { EmptyState } from '@/components/ui/empty-state';
import { Award01Icon } from '@/components/ui/icon/glyphs';
export function MarketTradersEmpty() {
  const $ = _c(7);
  const t = useTranslations("market.traders");
  let t0;
  if ($[0] !== t) {
    t0 = t("empty_title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("empty_subtitle");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <EmptyState framed={true} icon={Award01Icon} title={t0} description={t1} data-testid="market-traders-empty" />;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}